exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".invoice-setting[data-v-5ae31c0c] {\n  border: 0px !important;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  margin: 0;\n}\n.invoice-form label[data-v-5ae31c0c] {\n  padding-left: 15px !important;\n  text-align: left !important;\n}\n.character-count[data-v-5ae31c0c] {\n  font-size: 12px;\n  color: #666;\n  text-align: right;\n  margin-top: 5px;\n}\n.invoice-form .form-group .error[data-v-5ae31c0c] {\n  margin-top: 5px !important;\n  margin-bottom: 10px;\n}\n.invoice-footer-textarea[data-v-5ae31c0c] {\n  padding-left: 0px !important;\n  margin-top: 15px;\n}\n", ""]);

// exports
